import React, { Component } from 'react';

import './AddButton.scss';

export default class AddButton extends Component {
  render() {
    const { text, handleOnClick } = this.props;
    return (
      <div onClick={handleOnClick} className="AddButton">
        <div className="icon icon-plus" />
        <div className="text">{text}</div>
      </div>
    );
  }
}
